import _ from 'lodash';
import boolean from 'boolean';
import { setLocale } from '~/utils/i18n';
import { CreativePreview, adapi } from '~';

export default {
  components: {
    CreativePreview,
  },
  data() {
    return {
      loading: true,
      creative: null,
      landingPage: null,
      facebookPage: null,
      mobilePreview: boolean(this.$route.params.type),
    };
  },
  mounted() {
    return adapi.post(`/creative-preview/${this.$route.params.id}/get-preview`, null, { hash: this.$route.params.hash })
      .then(result => {
        if (result.interfaceLanguage) {
          setLocale(result.interfaceLanguage);
        }

        this.creative = result.data;
        this.landingPage = _.get(result, 'data.landingPage', null);
        this.facebookPage = _.get(result, 'data.facebookPage', null);
        this.loading = false;
      })
      .catch(e => {
        this.$toast.error({ message: e.toString() });
        this.loading = false;
      });
  },
};



// WEBPACK FOOTER //
// ./src/components/public-creative-preview/PublicCreativePreview.js